module.exports = require("Vue");